import React from 'react';

import styles from './kpi_cards.module.css';

// Shared KPI header row used across the Program Insights cards. Each card is { label, value } with an
// optional `hero` (navy emphasis tile) and `sub` (small caption under the value).
export default function KpiCards({ cards }) {
  if (!cards || cards.length === 0) {
    return null;
  }

  return (
    <div className={styles.grid} style={{ gridTemplateColumns: `repeat(${cards.length}, minmax(0, 1fr))` }}>
      {cards.map((card) => (
        <div key={card.label} className={`${styles.card} ${card.hero ? styles.hero : ''}`}>
          <div className={styles.label}>{card.label}</div>
          <div className={styles.valueRow}>
            <div className={styles.value}>{card.value}</div>
            {card.sub && <div className={styles.sub}>{card.sub}</div>}
          </div>
        </div>
      ))}
    </div>
  );
}
